<template>
    <div id="menuLinks">
            <li class="list-inline-item">
              <a href="#" @click="redirectURL({name: 'publications'})">Comprar Publicações</a>
            </li>
            <li class="list-inline-item dot">|</li>
            <li class="list-inline-item">
              <a href="#" @click="redirectURL({name: 'orders'})">Pedidos</a>
            </li>
            <li class="list-inline-item dot">|</li>
            <li class="list-inline-item">
              <a href="#" @click="redirectURL({name: 'manage'})">Gerenciador</a>
            </li>
            <li class="list-inline-item dot">|</li>
            <li class="list-inline-item">
              <a href="#" @click="redirectURL({name: 'cart'})"> <i class="fa fa-shopping-cart"></i>  <span class="badge badge-pill badge-primary">{{ countCartItems }}</span></a>
            </li>
            <li class="list-inline-item dot">|</li>
            <li class="list-inline-item">
              <a href="#" @click="redirectURL({name: 'contact'})"><i class="fa fa-envelope"></i></a>
            </li>
            <li v-show="is_partner" class="list-inline-item dot">|</li>
            <li v-show="is_partner" class="list-inline-item">
              <a href="#" @click="redirectURL({name: 'partner'})"><i class="fa fa-star"></i></a>
            </li>
            <li class="list-inline-item dot">|</li>
    </div>
</template>

<script>
  import mixins from "../../helpers/mixins";
  import { mapState } from 'vuex'
  export default {
    name: "links-menu",

    mixins: [mixins],
    computed: {
      ...mapState(['is_partner']),
      countCartItems() {
        let numberItems = this.$store.getters.getCartNumberItems
        return numberItems
      }
    }
  }
</script>

<style scoped>

</style>
